export enum Roles {
    Employee = 'employee',
    GlobalReports = 'globalReports',
    Management = 'management',
    MutationPreviousPeriod = 'mutationPreviousPeriod',
    PdfUnderlay = 'pdfUnderlay',
    SeireManagement = 'seireManagement',
}
